import { useAuthContext } from '@/features/auth/context/AuthContext';
import { BoardManagementPage } from '@/features/board/pages/BoardManagementPage';
import { BoardPmPage } from '@/features/board/pages/BoardPmPage';

/** BD-01 (Project Manager) vs BD-02 (Management) — isti obrazac grananja kao DashboardPage.tsx (OrgDashboardPage/PmDashboardPage). */
export const BoardPage = () => {
  const { user } = useAuthContext();

  return user?.role === 'ORGANISATION_ADMIN' ? <BoardManagementPage /> : <BoardPmPage />;
};
